/* eslint-disable unused-imports/no-unused-vars */
/* eslint-disable no-useless-catch */
import { API } from "../api";
import { ORDER_STATUSES } from "../constants/url.constant";

export const getOrderStatuses = (params = {}) => {
  return async (dispatch) => {
    try {
      const res = await API.get(ORDER_STATUSES);
      return res;
    } catch (error) {
      throw error;
    }
  };
};
